import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from 'src/components/ui/avatar';
import { components, GroupBase, OptionProps } from 'react-select';
import { User2 } from 'lucide-react';
import { OptionObject } from 'src/components/ReactSelectInput';
import { str } from 'src/lib/utils';

const EditorSelectOption = <T extends Record<string, any>>({
  ...props
}: OptionProps<OptionObject<T>, boolean, GroupBase<OptionObject<T>>>): JSX.Element => {
  const data = props.data;

  return (
    <components.Option {...props}>
      <div className={'tw-flex tw-items-center tw-gap-3 tw-w-full tw-min-w-0 tw-py-1'}>
        <Avatar size={'sm'} className={'tw-flex-shrink-0'}>
          {!data.value ? (
            <AvatarFallback className={'tw-bg-neutral-400 tw-text-white'}>
              <User2 size={16} />
            </AvatarFallback>
          ) : (
            <>
              <AvatarImage
                className={'tw-object-cover'}
                src={data.avatar?.generated_conversions.square_200 ?? data.avatar?.index_url}
                alt={str.acronym(data.label as string)}
              />
              <AvatarFallback className={'tw-bg-orange tw-text-white'}>
                {str.acronym(data.label as string)}
              </AvatarFallback>
            </>
          )}
        </Avatar>
        <div className={'tw-flex-1 tw-min-w-0 tw-flex tw-items-center tw-justify-between tw-gap-2'}>
          <span className={'tw-truncate tw-text-sm tw-font-medium'}>
            {data.label}
          </span>
          {data.description && (
            <div className={'tw-flex-shrink-0'}>
              {data.description}
            </div>
          )}
        </div>
      </div>
    </components.Option>
  );
};

export { EditorSelectOption };
